import { Transportadora } from '../../../types/transportadoras'
import transportadorasService from './transportadorasService'

const buscarTransportadoras = async (): Promise<Transportadora[]> => transportadorasService.buscarTransportadoras()

export default {
  buscarTransportadoras
}
